import { Box, Modal } from "@mui/material";

import Header from "./components/Header";
import Content from "./components/Content";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: "800px",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  overflow: "hidden",
};

const SubscriptionModal = ({
  subscriptionModal,
  modalTitle,
  contentTitle,
  content,
  isLoadingTrigger,
  onTrigger,
  isOpen,
  setIsOpen,
  imageSrc,
}) => {
  return (
    <Modal open={isOpen}>
      <Box sx={style}>
        <Header modalTitle={modalTitle} setIsOpen={setIsOpen} />
        <Content
          contentTitle={contentTitle}
          content={content}
          isLoadingTrigger={isLoadingTrigger}
          onTrigger={onTrigger}
          setIsOpen={setIsOpen}
          imageSrc={imageSrc}
          subscriptionModal={subscriptionModal}
        />
      </Box>
    </Modal>
  );
};

export default SubscriptionModal;
